import React, { PureComponent } from 'react';
import { Image, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { Button, ButtonSize } from '../../components';
import { APP_STORE_LINK, PLAY_STORE_LINK } from '../../config';
import Theme from '../../theme';
import { getOSOnWeb, WebOS   } from '../../utils';
import { Logger } from '../../utils/Logger';
import { defaultScale } from '../../utils/scaling';
import { openLink } from '../../utils/linkUtils';

interface IProps {
  containerStyle?: ViewStyle;
  overrideLink?: string;
  useButtonStyle?: boolean;
  t(key: string): string;
}

export class InstallAppButton extends PureComponent<IProps> {
  public openAndroid = () => {
    this.tryOverrideThenFallback(PLAY_STORE_LINK)
      .catch((e) => Logger.notify(e));
  }

  public openIos = () => {
    this.tryOverrideThenFallback(APP_STORE_LINK)
      .catch((e) => Logger.notify(e));
  }

  public render() {
    const webOS = getOSOnWeb();
    const { useButtonStyle, t } = this.props;

    if (useButtonStyle) {
      return (
        <Button
          onPress={webOS === WebOS.Android ? this.openAndroid : this.openIos}
          title={t('bookings:continueToAppSetup')}
          size={ButtonSize.MEDIUM}
          fontColor={Theme.WHITE}
          containerStyle={styles.button}
        />
      );
    }

    return (
      <>
        {webOS === WebOS.Android &&
          <TouchableOpacity onPress={this.openAndroid} style={this.props.containerStyle}>
            <Image
              style={styles.image}
              resizeMode={'contain'}
              source={require('../../assets/images/google-play-badge.png')}
            />
          </TouchableOpacity>
        }
        {webOS === WebOS.iOS &&
          <TouchableOpacity onPress={this.openIos} style={this.props.containerStyle}>
            <Image
              style={styles.image}
              resizeMode={'contain'}
              source={require('../../assets/images/ios-play-badge.png')}
            />
          </TouchableOpacity>
        }
      </>
    );
  }

  private tryOverrideThenFallback = async (fallback: string) => {
    const { overrideLink } = this.props;
    if (overrideLink) {
      try {
        await openLink(overrideLink);
      } catch {
        await openLink(fallback);
      }
    } else {
      await openLink(fallback);
    }
  }
}

const styles = StyleSheet.create({
  image: {
    width: defaultScale(190),
    height: defaultScale(60),
  },
  button: {
    marginTop: defaultScale(30),
  },
});
